import asyncSeries from 'async/series';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  fetch,
  getVersionList,
};

const g_packageMap: Map<string, any> = new Map();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function getVersionList(package_name: string) {
  return g_packageMap.get(package_name);
}

function fetch(done?: (err: any) => void) {
  asyncSeries(
    [
      (done) => _fetchPackage('avid-fs', done),
      (done) => _fetchPackage('abt-media-sync', done),
    ],
    (err) => {
      if (done) {
        done(err);
      }
    }
  );
}

function _fetchPackage(package_name, done) {
  const opts = {
    url: `/api/1/client_version/${package_name}`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('ClientVersionStore._fetchPackage: err:', err);
    } else if (body && body.client_list) {
      const client_list = _fixupList(body.client_list);
      g_packageMap.set(package_name, client_list);
      _emit('change');
    }
    done(err);
  });
}

function _fixupList(list) {
  const ret = [];
  list.forEach((client) => {
    client.last_updated_time = Date.parse(client.last_updated);
  });

  list.forEach((client) => {
    client.hostname = client.hostname.split('.')[0];
    const old = ret.find((l) => l.hostname === client.hostname);
    if (old) {
      if (old.last_updated_time < client.last_updated_time) {
        Object.assign(old, client);
      }
    } else {
      ret.push(client);
    }
  });

  return ret.sort(_sortHost);
}

function _sortHost(a, b) {
  return a.hostname.localeCompare(b.hostname);
}
